import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ShortTextInput.module.css";

function ShortTextInput({
  label,
  defaultValue,
  error,
  helperText,
  id,
  onChange,
  value,
  placeholder,
  fullWidth,
  labelColor,
  className = '',
  containerClassName = '',
  style,
  disabled,
  required, // show required field indicator if true
  type = "text", // Default to text input by default
  prefix, // generic prefix (currency symbol, etc)
}) {
  return (
    <div
      className={`${containerClassName}`}
      style={{
        width: fullWidth ? "100%" : "auto",
        marginBottom: "1rem",
      }}
    >
      {/* Label */}
      {label && <Label id={id} required={required} label={label} />}

      {/* Input with optional prefix */}
      <div className={styles.inputWrapper}>
        {prefix && <span className={styles.dollarPrefix}>{prefix}</span>}
        <input
          id={id}
          type={type}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          placeholder={placeholder}
          className={classNames(
            styles.inputBase,
            prefix ? styles.inputWithPrefix : '',
            {
              [styles.inputError]: error,
              [styles.inputDisabled]: disabled,
            },
            className
          )}
          style={style}
          aria-describedby={`${id}-helper-text`}
          disabled={disabled}
        />
      </div>

      {/* Helper Text */}
      {(helperText || error) && (
        <HelperError id={id} error={error} helperText={helperText} />
      )}
    </div>
  );
}

// Default Props
ShortTextInput.defaultProps = {
  label: "",
  defaultValue: "",
  error: "",
  helperText: "",
  id: "custom-input",
  onChange: () => {},
  value: "",
  placeholder: "",
  fullWidth: false,
  labelColor: "", // Default to theme color
  prefix: undefined,
};

// Prop Types
ShortTextInput.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  labelColor: PropTypes.string, // Accepts a custom color for the label
  prefix: PropTypes.node,
};

export default ShortTextInput;

export const Label = ({ id, required, label }) => (
  <label htmlFor={id} className="p4 mb-1 fw-semibold text-capitalize">
    {label}
    {required && <span className="text-danger"> *</span>}
  </label>
);

export const HelperError = ({ id, error, helperText }) => {
  return (
    <p
      id={`${id}-helper-text`}
      className={error ? "p4 text-danger text-start" : "p4 text-muted mb-0"}
    >
      {error || helperText}
    </p>
  );
};
